import map_tag from 'shared/map_tag'

export default map_tag(encodeURIComponent)
